import React, { useRef, useEffect, useState, useContext } from 'react';
import Container from '@material-ui/core/Container';
import Modal from '@material-ui/core/Modal';
import FilledInput from '@material-ui/core/FilledInput';
import Button from '@material-ui/core/Button';
import Cookies from 'js-cookie';

import '../../../scss/components/_signal_planning.scss';
import API_PATH from "../../../constants/config.json";
import MapContext from '../../../context/MapContext';
const API_URL = process.env.REACT_APP_BASE_URL;
const axios = require('axios');


const CreateScenario = props => {

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [defaultDate, setDefaultDate] = useState(null);
    const [defaultPeriod, setDefaultPeriod] = useState(null);
    const { updateStationDetails } = useContext(MapContext);

    useEffect(() => {
        if(props.peakData) {
            setDefaultDatePeriod();
        }
    }, [props.peakData])
    
    const setDefaultDatePeriod = () => {
        let dates = props.peakData;
        if(dates[0]) {
            let dt = handleFormatDate(dates[0]);
            let period = dates[0].pm.count > 0 ? "PM" : dates[0].mid.count > 0 ? "MID" : "AM";
            setDefaultDate(dt);
            setDefaultPeriod(period);
        }
    }

    const handleFormatDate = (obj, format) => {
        let dt = null;
        if(format === 'yr') {
            let tmp = new Date(obj);
            dt = (tmp.getMonth()+1)+"/"+tmp.getDate()+"/"+tmp.getFullYear();
        } else {
            if(obj.am && obj.am.startdate) {
                let tmp = obj.am.startdate.split("T");
                dt = tmp[0];
            } else if(obj.mid && obj.mid.startdate) {
                let tmp = obj.mid.startdate.split("T");
                dt = tmp[0];
            } else if(obj.pm && obj.pm.startdate) {
                let tmp = obj.pm.startdate.split("T");
                dt = tmp[0];
            }
        }
        return dt;
    }

    const handleCreateScenario = () => {
        let stationId = props.stationData.station_id;
        let obj = {
            stationId,
            name,
            description,
            date_count: defaultDate,
            period: defaultPeriod
        }
        try {
            axios({
                method: 'post',
                data: obj,
                url: API_URL + API_PATH.saveScenario,
                headers: {
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {
                    if (response && response.status == '200') {
                        props.setShowNewScenario(false)
                        props.setReloadScenarios(true);
                        if(response.data.data) {
                            let id = response.data.data['scenario_id'];
                            props.setNewScenarioId(id);
                            updateStationDetails({
                                station_id: response.data.data['FK_station_id']
                            });
                        }
                    } 
                })
                .catch((err) => {
                    console.error(err);        
                })
        } catch (error) {
            console.error(error);
        }
    }
    
    const handleEnterKey = (e) => {
        if(e.key === 'Enter') {
            e.preventDefault();
            setName("");
            setDescription("");
            handleCreateScenario();
        }
    }

    return (
        <Modal
            open={props.showNewScenario}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description" 
            className={'z_index_test'}             
        >
            <div className="create-scenario-main">
                <Container className="create-scenario-container" maxWidth="lg">
                    <div>
                        <div className='new-header'>
                            <label>Create scenario</label>
                            <p>Create a new scenario with the information below</p>
                            <img src={require('../../../assets/icons/close.svg')} onClick={() => props.setShowNewScenario(false)} />
                        </div>
                        <form>
                            <div className="station-detail-childt">
                                <label className={'general-label'}>Scenario name</label>
                                <FilledInput   
                                    id="intersection_Approaches_text_4" 
                                    name="intersection_Approaches_text_4"
                                    className={"form-text-input"} 
                                    type="text" 
                                    value={name}
                                    variant="outlined" 
                                    onChange={(e) => setName(e.target.value)} 
                                    data-testid="intersection_Approaches_text_4" 
                                    onKeyPress={handleEnterKey}
                                />
                            </div> 
                            <div className="station-detail-childt">
                                <label className={'general-label'}>Scenario description</label>
                                <textarea className='form-text-area'
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)} 
                                    maxLength={250}
                                ></textarea> 
                            </div> 
                            <div className='buttons-footer'>
                                <Button type="reset" variant="outlined" id="cancel_btn" 
                                data-testid="cancel_btn" 
                                className={'cancel-btn font-14'} 
                                onClick={() => props.setShowNewScenario(false)}
                                >
                                    Cancel</Button>
                                <Button type="reset" variant="outlined" id="cancel_btn" 
                                data-testid="cancel_btn" 
                                className={'blue-btn font-14'} 
                                onClick={handleCreateScenario}
                                disabled={name === ""}
                                >
                                    Create</Button>
                            </div>
                        </form>
                    </div>
                </Container>
            </div>
        </Modal>
    )

}

export default CreateScenario;